"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeMarginShorthand = exports.openMarginShorthand = void 0;
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var css_data_types_1 = require("../../css-data-types");
// margin
var openMarginShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpenerFromPart)({
        prop: 'margin',
        dataType: css_data_types_1.ALWAYS_DATA_TYPE,
        partOpener: (0, shorthand_parser_utils_1.edgesShorthandOpener)('margin'),
        openedProps: ['margin-top', 'margin-right', 'margin-bottom', 'margin-left'],
    });
};
exports.openMarginShorthand = openMarginShorthand;
var closeMarginShorthand = function () { return (0, shorthand_parser_utils_1.edgesShorthandCloser)('margin'); };
exports.closeMarginShorthand = closeMarginShorthand;
//# sourceMappingURL=margin-shorthand.js.map